import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import {
  UnauthenticatedRoute,
  ProtectedRoute,
  ROOT,
  LOGIN,
  SIGNUP_REQUEST,
  SIGNUP,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD,
  PORTAL_DISABLED,
} from 'ui_system/token_auth/routes';

import LoginPage from 'ui_system/token_auth/LoginPage';
import SignUpRequestPage from 'ui_system/token_auth/SignUpRequestPage';
import SignUpPage from 'ui_system/token_auth/SignUpPage';
import ResetPasswordRequestPage from 'ui_system/token_auth/ResetPasswordRequestPage';
import ResetPasswordPage from 'ui_system/token_auth/ResetPasswordPage';
import { PortalDisabledPage } from 'ui_system/token_auth/PortalDisabledPage';

import Api from 'data_system/resource_portal/api';
import SlotList from './slots/SlotList';
import SlotDetails from './slots/SlotDetails';
import ExperienceList from './experiences/ExperienceList';
import ExperienceEdit from './experiences/edit/ExperienceEdit';
import Profile from './resource/Profile';

import {
  PROFILE,
  SLOT_LIST,
  SLOT_DETAILS,
  EXPERIENCE_LIST,
  EXPERIENCE_EDIT,
} from './routes';

const Router = ({ i18n }) => {
  return (
    <Switch>
      <UnauthenticatedRoute path={SIGNUP}>
        <SignUpPage submitText="Continue" />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={SIGNUP_REQUEST}>
        <SignUpRequestPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={LOGIN}>
        <LoginPage signupRequest />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={PORTAL_DISABLED}>
        <PortalDisabledPage />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={RESET_PASSWORD_REQUEST}>
        <ResetPasswordRequestPage
          resetPasswordRequest={Api.resetPasswordRequest}
        />
      </UnauthenticatedRoute>

      <UnauthenticatedRoute path={RESET_PASSWORD}>
        <ResetPasswordPage />
      </UnauthenticatedRoute>

      <ProtectedRoute path={PROFILE}>
        <Profile />
      </ProtectedRoute>

      <ProtectedRoute path={SLOT_DETAILS}>
        <SlotDetails />
      </ProtectedRoute>

      <ProtectedRoute exact path={SLOT_LIST}>
        <SlotList />
      </ProtectedRoute>

      <ProtectedRoute path={EXPERIENCE_EDIT}>
        <ExperienceEdit i18n={i18n} />
      </ProtectedRoute>

      <ProtectedRoute exact path={EXPERIENCE_LIST}>
        <ExperienceList />
      </ProtectedRoute>

      <Redirect from={ROOT} exact to={SLOT_LIST} />
      <Redirect to={ROOT} />
    </Switch>
  );
};

export default Router;
